import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./module-auth/module-auth.module').then(m => m.ModuleAuth)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./module-dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '**',
        loadChildren: () => import('./module-not-found/module-not-found.module').then(m => m.ModuleNotFound)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'corrected' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
